import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  androidtv: {
    height: spacing(2.5),
  },
  appletv: {
    height: spacing(3),
  },
  lg: {
    height: spacing(3.5),
  },
  samsung: {
    height: spacing(2.5),
  },
  fallback: {
    width: spacing(5),
    height: spacing(5),
    alignItems: "center",
    justifyContent: "center",
  },
  fallbackIcon: {
    width: spacing(5),
    height: spacing(5),
    color: colors.foregroundDefault,
  },
}));

export default stylesheet;
